import { render } from "./Chat.vue?vue&type=template&id=45b799c1&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=ts"
export * from "./Chat.vue?vue&type=script&lang=ts"

import "./Chat.vue?vue&type=style&index=0&id=45b799c1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-45b799c1"

export default script